<template>
    <v-container>
        <v-row class="my-2 subtitle-2 secondary--text pl-12">
            {{'Team profile' | localize}}
        </v-row>
        <div v-if="user" class="body-2">
            <v-row justify="end">
                <v-btn color="secondary"
                    class="text-capitalize mt-4"
                    plain 
                    @click="logOut()">
                    <v-icon>mdi-logout</v-icon>
                    {{ 'log Out' | localize }}
                </v-btn>
            </v-row>
            <v-row>{{ 'Name' | localize }}: {{ user.name }}</v-row>
            <v-row>{{ 'Email' | localize }}: {{ user.email }}</v-row>
            <v-row>{{ 'Role' | localize }}: {{ user.role }}</v-row>
            <v-divider class="my-4"></v-divider>  
        </div>
    </v-container>
</template>

<script>

export default {
    name: 'Profile',
    data() {
        return {
        }
    },
    computed: {
        user() {
            return this.$store.getters.user;
        }
    },
    watch: {
        user() {
            if (!this.user) {
                this.$router.push('/');
            }
        }
    },
    methods: {
        dateToString(date) {
            return date.toLocaleString('en-GB', { timeZone: 'UTC' }).substr(0, 10);
        },
        async logOut() {
            try {
                await this.$store.dispatch('logout', this.user.id);
            }
            catch (error) {
                await this.$store.dispatch('setError', error.message);
            }
        }
    },
    components: {},
    
}
</script>
